import { useEffect } from 'react';

import logger from '~/shared/utils/logger';
import { useSessionActions } from '~/techstyle-shared/redux-core';

const debug = logger.extend('grid:reportAlgorithmTrace');

const algorithmTraceDetailKey = 'algorithmTrace';
const algoTraceTypes = {
  AD_ID_ALGO: 'adId_algo',
  AD_ID_FPL: 'adId_fpl',
  GEO_ALGO: 'geo_algo',
  GEO_FPL: 'geo_fpl',
  FPL: 'fpl',
};
const algoTraceActionTypes = {
  SUCCESS: 'boostedIds',
  FALLBACK: 'fallbackFpl',
  NONE: 'none',
};

export function useReportAlgorithmTrace(trace = {}) {
  const sessionActions = useSessionActions();

  const { action = '', type } = trace;
  const isAdId = type === 'adId';
  const [actionType] = action.split(':');

  let algorithmTraceReport = algoTraceActionTypes.NONE;

  if (actionType === algoTraceActionTypes.SUCCESS) {
    algorithmTraceReport = isAdId
      ? algoTraceTypes.AD_ID_ALGO
      : algoTraceTypes.GEO_ALGO;
  } else if (actionType === algoTraceActionTypes.FALLBACK) {
    algorithmTraceReport = isAdId
      ? algoTraceTypes.AD_ID_FPL
      : algoTraceTypes.GEO_FPL;
  } else {
    debug('No reportable action found', actionType);
  }

  const detail = {
    name: algorithmTraceDetailKey,
    value: algorithmTraceReport,
  };

  useEffect(() => {
    if (detail.value !== algoTraceActionTypes.NONE) {
      debug('Setting algorithm trace', detail);
      sessionActions.updateSessionDetail(detail, {
        shouldInvalidateFeatures: false,
      });
    }
    // we should explicitly set `detail.value` as a dependency to this useEffect
    // so that we only run this when `detail.value` changes. exhaustive-deps has
    // been disabled below as the rule wants `detail` to also be included but
    // we do not care about that as a dependency as the reference will be new
    // with every call of `useReportAlgorithmTrace` on each re-render of its
    // consumers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail.value, sessionActions]);
}
